
import axios from 'axios';
import config from '../config.js';

// 默认的SEO配置
const defaultSeo = {
  title: '利康科技_权威保健食品数据库',
  keywords: '保健食品批文查询,批文转让',
  description: '利康科技是专注保健食品行业的权威平台'
};

// 更新页面SEO信息
export const updateSeo = (seoData) => {
  if (seoData.title) {
    document.title = seoData.title;
  }

  // 更新或创建keywords meta标签
  let keywordsMeta = document.querySelector('meta[name="keywords"]');
  if (keywordsMeta) {
    keywordsMeta.setAttribute('content', seoData.keywords || '');
  } else {
    keywordsMeta = document.createElement('meta');
    keywordsMeta.name = 'keywords';
    keywordsMeta.content = seoData.keywords || '';
    document.head.appendChild(keywordsMeta);
  }

  // 更新或创建description meta标签
  let descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute('content', seoData.description || '');
  } else {
    descriptionMeta = document.createElement('meta');
    descriptionMeta.name = 'description';
    descriptionMeta.content = seoData.description || '';
    document.head.appendChild(descriptionMeta);
  }
};

// 从后端获取SEO数据
export const fetchSeoData = async (route) => {
  try {
    // 根据当前路由信息获取SEO配置
    const response = await axios.get(`${config.API_BASE_URL}/api/seo-config`, {
      params: {
        path: route.path,
        name: route.name,
        params:  encodeURIComponent(route.params)
      }
    });
    console.log(response);

    return response.data.data;
  } catch (error) {
    console.error('获取SEO配置失败:', error);
    return defaultSeo;
  }
};
